import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfirmButton = ({
  isVideo2AssumedOptedIn,
  isUpdatePending,
  onSubmit
}) => {
  return /*#__PURE__*/_jsx(UILoadingButton, {
    use: "primary",
    loading: isUpdatePending,
    preventClicksOnLoading: true,
    onClick: onSubmit,
    onLoadingFinish: () => console.log('onLoadingFinish'),
    "data-confirm-button": "accept",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: isVideo2AssumedOptedIn ? 'FileManagerCore.videoOptIn.modal.submitButton.keepOn' : 'FileManagerCore.videoOptIn.modal.submitButton.turnOn'
    })
  });
};
const TurnOnVideoFeaturesModal = ({
  isUpdatePending,
  onSubmit,
  onClose,
  isVideo2AssumedOptedIn
}) => {
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    use: "success",
    width: 800,
    message: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: isVideo2AssumedOptedIn ? 'FileManagerCore.videoOptIn.modal.turnOn.header.keepOn' : 'FileManagerCore.videoOptIn.modal.turnOn.header.turnOn'
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "FileManagerCore.videoOptIn.modal.turnOn.message"
    }),
    ConfirmButton: ConfirmButton,
    confirmButtonProps: {
      isVideo2AssumedOptedIn,
      isUpdatePending,
      onSubmit
    },
    onConfirm: onSubmit,
    onReject: onClose,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerCore.videoOptIn.modal.cancel"
    }),
    "data-test-id": "turn-on-video-modal"
  });
};
export default TurnOnVideoFeaturesModal;